import { Box, Flex, Image, Input, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  AddDimnesionGroupItem,
  fetchDimensionItemsGroup,
  getGroupItem,
  setGroupItem,
} from 'redux/ItemPageSlice';
import {
  FetchBlockItemDimensions,
  getSelectedDriver,
  handleFilters,
  resetFilters,
} from 'redux/PlanPageSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import { usePlanPageRevampVariant } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/usePlanPageUiRevamp';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import arrowDown from '../Icons/arrowDown.svg';

interface AddNewItemProperties {
  dataKey: any;
  styles: any;
  planPermission?: boolean;
  refetchRequest?: any;
  variant?: 'legacy' | 'revamp';
}

const AddNewItem = ({
  dataKey,
  styles,
  planPermission,
  variant = 'legacy',
}: AddNewItemProperties) => {
  const isRevamp = usePlanPageRevampVariant(variant);
  const themeColors = useSelector(getPlanPageThemeColors);
  const [itemName, setItemName] = useState('');
  const { blockId } = useParams();
  const dispatch: AppDispatch = useDispatch();

  const groupItem = useSelector(getGroupItem);
  const currentDriver = useSelector(getSelectedDriver);
  const baseScenario = useSelector(getBaseScenario);

  const dimensionId = currentDriver?.dim_id;
  const requestBody = {
    name: itemName,
    properties: [
      {
        property_id: currentDriver?.group_property_id,
        value: groupItem,
      },
    ],
    scenario_id: baseScenario?.id,
  };

  const AddItem = async () => {
    const addDimGroupItem: any = await dispatch(
      AddDimnesionGroupItem({
        dimension_id: dimensionId,
        request_body: requestBody,
        toaster: {
          successMessage: 'Successfully added',
          errorMessage: 'An item with this name already exists',
        },
      }),
    );
    if (!addDimGroupItem?.error) {
      await dispatch(fetchDimensionItemsGroup({ currentDriver, scenario_id: baseScenario?.id }));
      await setItemName('');
      await dispatch(
        FetchBlockItemDimensions({
          blockId,
        }),
      );
      await dispatch(handleFilters());
      await dispatch(resetFilters());
    }
  };

  const addNewItem = () => {
    const addItem = itemName.trim().length > 0;
    if (addItem) {
      AddItem();
    }
  };

  return (
    <>
      {groupItem === dataKey?.name ? (
        <Flex
          textAlign='left'
          alignSelf='left'
          w='100%'
          minH={isRevamp ? 'auto' : '50px'}
          bgColor={isRevamp ? themeColors.activeBg : '#7163D0'}
          border={isRevamp ? '1px solid' : 'none'}
          borderColor={isRevamp ? themeColors.border : undefined}
          mb={isRevamp ? '12px' : '10px'}
          p='0'
          flexDirection='column'
          borderRadius={isRevamp ? '8px' : '14px'}
          filter={isRevamp ? 'none' : 'drop-shadow(0px 0px 15.998px rgba(0, 0, 0, 0.25))'}
          transition='all 0.3s ease-out'
          css={isRevamp ? undefined : styles.container(true)}
        >
          <Box position='relative' p={isRevamp ? '12px' : '16px'}>
            <Flex justifyContent='space-between'>
              <Text
                fontFamily={isRevamp ? 'bold' : 'Roboto Regular'}
                fontSize={isRevamp ? '14px' : '1xl'}
                lineHeight={isRevamp ? '1.2' : '9'}
                color={isRevamp ? themeColors.textDark : '#FFFFFF'}
                fontWeight={isRevamp ? '700' : undefined}
              >
                <Input
                  fontSize='16px'
                  placeholder='New Item'
                  autoFocus
                  onChange={(event: any) => {
                    setItemName(event.target.value);
                  }}
                  isDisabled={!!planPermission}
                  onKeyDown={
                    planPermission
                      ? undefined
                      : (event) =>
                          event.code === 'Enter' && event.target.value.trim().length > 0
                            ? AddItem()
                            : null
                  }
                  onBlur={
                    planPermission
                      ? undefined
                      : (event: any) =>
                          event.target.value ? AddItem() : dispatch(setGroupItem(null))
                  }
                  color={isRevamp ? themeColors.textDark : '#FFFFFF'}
                  border={isRevamp ? `1px solid ${themeColors.border}` : 'none'}
                  borderRadius={isRevamp ? '8px' : undefined}
                  _placeholder={{
                    color: isRevamp ? themeColors.textSecondary : '#ffffff66',
                    fontSize: '16px',
                  }}
                />
              </Text>
              <Image src={arrowDown} w='12px' onClick={addNewItem} />
            </Flex>
          </Box>
        </Flex>
      ) : null}
    </>
  );
};

export default AddNewItem;
